import { Box } from '@mui/material';

import { editTourSequence } from '@/domain/project-tour-ontour/actions/edit-tour-sequence.action';
import { TourSequence } from '@/domain/project-tour-ontour/entities/project-tour-ontour-sequence.entity';
import { FSModal } from '@/ui/components/modal/FSModal';
import { FSModalTitle } from '@/ui/components/modal/FSModalTitle';
import { useAppDispatch } from '@/ui/hook/store';
import { translate } from '@/ui/i18n';

import { TourSequenceForm, TourSequenceFormInput } from './TourSequenceForm';

export function ModalTourSequenceEdit({
  open,
  onClose,
  sequence,
}: {
  open: boolean;
  onClose: () => void;
  sequence: TourSequence | null;
}) {
  const dispatch = useAppDispatch();

  if (!sequence) {
    return null;
  }

  const onSubmit = async (data: TourSequenceFormInput) => {
    const params = {
      tourSequence: { ...sequence, name: data.name },
    };
    try {
      await dispatch(editTourSequence(params)).unwrap();
      onClose();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <FSModal open={open} onClose={onClose}>
      <FSModalTitle
        title={translate('ProjectsTour.SequenceForm.edit-form-title')}
      />
      <Box sx={{ height: '1rem' }} />
      <TourSequenceForm
        sequence={sequence}
        onClose={onClose}
        onSubmit={onSubmit}
      />
    </FSModal>
  );
}
